<template>
    <div v-loading="loadingInv">
        <div class="page-invoice scrollable">
            <div class="toolbar" v-if="!showAlert">
                <el-row>
                    <el-col :span="12">
                        <div>
                            <el-select v-model="selectedMonth" placeholder="Select Month" style="float:left; margin: 5px 10px 5px 0;">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-button class="" @click="getBilling" style="float:left; margin: 5px 0 5px 0;" :loading="btnLoading">Ok</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-button class="animated fadeInRight" style="margin: 5px 0 5px 0;" plain @click="getBilling('download')"><i class="mdi mdi-download" /> Download</el-button>
                    </el-col>
                </el-row>
                <!-- <el-button class="ml-10" @click="clear" style="float:left">Reset</el-button> -->
            </div>

            <div class="invoice bg-white black-text" v-if="!showAlert">
                <div class="invoice-top">
                    <div class="logo">
                        <img src="@/assets/images/logo-cropped.png" alt="logo">
                    </div>
                    <div class="info">
                        <h2>DAM Corp.</h2>
                        <p>daisy@damcorp.id<br>(021) 30487010</p>
                    </div><!--End Info-->
                    <div class="title">
                        <h1>Invoice</h1>
                        <!-- <p>Issued: {{ today }}</p> -->
                    </div><!--End Title-->
                </div><!--End InvoiceTop-->
                <hr>
                <div class="invoice-bottom">
                    <!-- HEADER -->
                    <el-row :gutter="0" style="margin-top: 20px">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="header-text">Service Description</span>
                        </el-col>
                        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                            <span class="header-text">Type</span>
                        </el-col>
                        <el-col :xs="4" :sm="12" :md="4" :lg="4" :xl="4">
                            <span class="header-text">Total Message</span>
                        </el-col>
                        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                            <span class="header-text">Sub total</span>
                        </el-col>
                    </el-row>
                    <hr />
                    <!-- BODY -->
                    <el-row :gutter="0" v-for="(data, key) in dataBilling" :key="key">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-bottom: 20px">
                            <span><b>Whatsapp Business ({{ dataNumber[key] }})</b></span>
                        </el-col>
                        <hr/>
                        <el-row :gutter="0" v-for="(dt, k) in dataBilling[key]" :key="k" style="margin-bottom: 0px">
                            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" style="margin-bottom: 10px">
                                &nbsp;
                            </el-col>
                            <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9" style="margin-bottom: 10px">
                                {{ dt.product.productName }}
                            </el-col>
                            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="margin-bottom: 10px">
                                {{ capitalizeFirstLetter(dt.product.type) || '&nbsp;' }}
                            </el-col>
                            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="margin-bottom: 10px">
                                {{ dt.product.type.toLowerCase().indexOf('notification') != -1 && dt.detail.length > 0 ? '&nbsp;' : dt.delivered.toLocaleString('id') }}
                            </el-col>
                            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="margin-bottom: 10px">
                                {{ dt.product.type.toLowerCase().indexOf('notification') != -1 && dt.detail.length > 0 ? '&nbsp;' : "Rp " + dt.total.toLocaleString('id', { minimumFractionDigits: Number.isInteger(dt.total) == false ? 4 : undefined }) }}
                            </el-col>
                            <hr />
                            <el-row :gutter="0" v-if="dt.product.type.toLowerCase().indexOf('notification') != -1 && dt.detail.length > 0" v-for="(dtl, indx) in dt.detail" :key="indx">
                                <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3" style="margin-bottom: 10px">
                                    &nbsp;
                                </el-col>
                                <el-col :xs="13" :sm="9" :md="9" :lg="9" :xl="9" style="margin-bottom: 10px">
                                    {{ dtl.countryCode }}
                                </el-col>
                                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="margin-bottom: 10px">
                                    {{ dtl.name }}
                                </el-col>
                                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="margin-bottom: 10px">
                                    {{ dtl.count.toLocaleString('id') || '0' }}
                                </el-col>
                                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="margin-bottom: 10px">
                                    Rp {{dtl.total.toLocaleString('id', { minimumFractionDigits: Number.isInteger(dtl.total) == false ? 4 : undefined }) }}
                                </el-col>
                                <hr />
                            </el-row>
                        </el-row>
                    </el-row>
                    <!-- FOOTER -->
                    <el-row :gutter="0">
                        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                            <h2 style="font-size: 24px">Total</h2>
                        </el-col>
                        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <h2 style="font-size: 24px">Rp {{ dataTotalBilling.toLocaleString('id', { minimumFractionDigits: Number.isInteger(dataTotalBilling) == false ? 4 : undefined }) }}</h2>
                        </el-col>
                    </el-row>
                </div><!--End Invoice-->
            </div>
        </div>
        <el-alert title="Info" type="info" description="No Data" show-icon v-if="showAlert"></el-alert>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
export default {
    props: {
        billing: {
            type: Array,
        },
        totalBilling:{
            type: Number
        },
        showAlert: {
            type: Boolean
        },
        loadingInvoice: {
            type: Boolean
        },
        number:{
            type: Array
        }
    },
    data(){
        return {
            today: moment().format("dddd, DD MMM YYYY"),
            getToday: moment().format('DD MMM YYYY'),
		getMonth: moment().month()+1,
            selectedMonth: moment().format("YYYY-MM"),
            btnLoading: false,
            dataBilling: this.billing,
            loadingInv: false,
            dataTotalBilling:this.totalBilling,
            dataNumber: this.number,
            options: [],
        }
    },
    methods: {
        print() {
			window.print()
        },
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
        },
        async changeFilter(){
			await this.getBilling()
        },
        async getBilling(query = ""){
            this.btnLoading = true

            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/billing",
                method: 'post',
                data:{
                    months: this.selectedMonth,
                    with_date: false
                },
                timeout: (10 * 60) * 1000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        this.dataTotalBilling = 0
                        _.forEach(res.data.data, dt => {
                            tempNumber.push(dt.phone_number)
                            tempBilling[i] = new Array()
                            let tempTax = new Array()
                            let j = 0
                            _.forEach(dt.billing, billing => {
                                let dtpush = {
                                    product: billing.product,
                                    delivered: billing.delivered,
                                    total: billing.billing,
                                    detail: billing.detail ? billing.detail.filter(v => v.count > 0) : billing.detail
                                }
                                // console.log('servicefee,',billing.detail.filter(v => v.count > 0))
                                if(billing.serviceFee){
                                    this.dataTotalBilling += parseFloat(billing.serviceFee)
                                    tempTax.push({ product: { productName: "Service Fee", type: "" }, delivered: "", total: parseFloat(billing.serviceFee) })
                                }else {
                                    let fee = 0
                                    if(billing.detail) {
                                        billing.detail.forEach(e => {
                                            fee += parseFloat(e.serviceFee)
                                        })
                                        this.dataTotalBilling += parseFloat(fee)
                                        tempTax.push({ product: { productName: "Service Fee", type: "" }, delivered: "", total: parseFloat(fee) })
                                    }
                                }
                                // if(billing.serviceFeeTax){
                                //     this.dataTotalBilling += parseFloat(billing.serviceFeeTax)
                                //     tempTax.push({ product: { productName: "Service Fee Tax", type: "" }, delivered: "", total: parseFloat(billing.serviceFeeTax) })
                                // }
                                if(billing.billingTax){
                                    this.dataTotalBilling += parseFloat(billing.billingTax)
                                    tempTax.push({ product: { productName: billing.product.productName + " Tax", type: "" }, delivered: "", total: parseFloat(billing.billingTax) })
                                }
                                // console.log(dtpush)
                                tempBilling[i].push(dtpush)
                                if(j+1 == dt.billing.length){
                                    _.forEach(tempTax, tax => {
                                        tempBilling[i].push(tax)
                                    })
                                }
                                if(Array.isArray(billing.detail)) {
									billing.detail.forEach(detail => {
										this.dataTotalBilling += detail.total
									})
								} else {
									this.dataTotalBilling += billing.billing
								}
                                j++
                            })
                            i++;
                        })
                        // console.log("billing", this.dataBilling)
                        this.dataNumber = tempNumber
                        this.dataBilling = tempBilling
                    }
                } else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.btnLoading = false
				this.loadingInv = false
            })
        },
        clear(){
            this.selectedMonth = ''
            this.getBilling()
        }
    },
    async beforeMount(){
		for(let i = 6; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
			this.options.push({
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}) 
		}
	},
    watch:{
        billing: function() {
            this.dataBilling = this.billing
        },
        totalBilling: function() {
            this.dataTotalBilling = this.totalBilling
        },
        number: function() {
            this.dataNumber = this.number
        },
        loadingInvoice: function() {
            this.loadingInv = this.loadingInvoice
        }
    }
}
</script>
<style>
.header-text{
	font-weight: 700;
	color: #000;
	opacity: 0.7;
}
</style>

